// src/components/Header.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import "../styles/App.css";

function Header({ user }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.signOut();
    navigate("/login");
  };

  return (
    <header className="header">
      <div className="container">
        <h1>Client Tour Management</h1>
        {user ? (
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        ) : null}
      </div>
    </header>
  );
}

export default Header;
